"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderNavBar = exports.CollaboratorPageNavbarWithHydration = exports.CollaboratorPageNavbarName = void 0;
var react_1 = __importStar(require("react"));
var server_1 = __importDefault(require("react-dom/server"));
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("Project/Types");
var hydrationHelpers_1 = require("Public/Widgets/hydrationHelpers");
var Telemetry_1 = require("Telemetry");
var CollaboratorPageInfoPopover_1 = __importDefault(require("./CollaboratorPageInfoPopover"));
var Telemetry_2 = require("@CommonFrontend/Public/Telemetry/Telemetry");
var TelemetryEnums_1 = require("@CommonFrontend/Telemetry/TelemetryEnums");
var CollaboratorInviteModal_1 = __importDefault(require("./CollaboratorInviteModal"));
var CollaboratorCommentPopup_1 = __importDefault(require("./CollaboratorCommentPopup"));
var PresentationMode_1 = require("../PresentationMode/PresentationMode");
var classnames_1 = __importDefault(require("classnames"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var styles = __importStar(require("./CollaboratorPageNavbar.css"));
function fireOnClickTelemetry(telemetry, eventName) {
    var _a;
    telemetry.track(eventName, (_a = {},
        _a["".concat((0, lodash_1.snakeCase)(eventName), "_source")] = TelemetryEnums_1.TelemetrySource.CollaboratorPage,
        _a), {
        includeAuthAttrs: true,
    });
}
var CollaboratorPageNavbar = function (_a) {
    var editPageButtonUrl = _a.editPageButtonUrl, clientUrl = _a.clientUrl, publicApiBaseUrl = _a.publicApiBaseUrl;
    var _b = __read((0, react_1.useState)(""), 2), url = _b[0], setUrl = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), showInviteModal = _c[0], setShowInviteModal = _c[1];
    var telemetry = Telemetry_2.Telemetry.getInstance();
    var onCopyCollaboratorLinkClicked = (0, react_1.useCallback)(function (callback) {
        callback();
        fireOnClickTelemetry(telemetry, Telemetry_1.TelemetryEventName.CollaboratorLinkCopied);
    }, []);
    var onQwilrLogoOpened = (0, react_1.useCallback)(function () {
        fireOnClickTelemetry(telemetry, Telemetry_1.TelemetryEventName.QwilrLogoOpened);
        var isAuth = telemetry.getIsAuth();
        if (isAuth)
            window.open(clientUrl, "_blank");
        else
            setShowInviteModal(true);
    }, []);
    (0, react_1.useEffect)(function () {
        var link = "".concat(document.location.origin).concat(document.location.pathname);
        window.history.pushState(null, document.title, link);
        setUrl(link);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.navbar, tokens_1.darkTheme) },
            react_1.default.createElement(kaleidoscope_1.Stack, { paddingLeft: "xxs", direction: "horizontal", align: "center", gap: "xxs" },
                react_1.default.createElement(kaleidoscope_2.Button, { className: styles.logoWrapper, size: kaleidoscope_2.ButtonSize.Small, type: kaleidoscope_2.ButtonType.Tertiary, onClick: onQwilrLogoOpened },
                    react_1.default.createElement("img", { className: styles.logo, src: "/Public/Assets/Images/QwilrLogoText.svg", alt: "Qwilr logo" })),
                react_1.default.createElement("div", { className: styles.verticalSpacer }),
                react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxxs", paddingLeft: "xs", direction: "horizontal", align: "center" },
                    react_1.default.createElement(kaleidoscope_2.Text, { className: styles.title, size: "s", lineHeight: "compact", strong: true, secondary: true }, "Collaborator Preview"),
                    react_1.default.createElement(CollaboratorPageInfoPopover_1.default, null))),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs", paddingRight: "s", align: "center" },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal" },
                    react_1.default.createElement(kaleidoscope_2.Button, { className: styles.iconOnlyMobileButton, type: kaleidoscope_2.ButtonType.Tertiary, size: kaleidoscope_2.ButtonSize.Small, onClick: PresentationMode_1.startPresentationMode },
                        react_1.default.createElement(icons_1.FullScreen, null),
                        react_1.default.createElement("span", { className: styles.desktopOnlyLabel }, "Present")),
                    react_1.default.createElement(kaleidoscope_2.Button, { className: styles.iconOnlyMobileButton, type: kaleidoscope_2.ButtonType.Tertiary, size: kaleidoscope_2.ButtonSize.Small, href: function () { return "".concat(editPageButtonUrl, "?source=").concat(Types_1.COLLABORATOR_LINK_SOURCE); }, onClick: function () { return fireOnClickTelemetry(telemetry, Telemetry_1.TelemetryEventName.ProjectOpenIntent); }, openInSameTab: true },
                        react_1.default.createElement(icons_1.Edit, null),
                        react_1.default.createElement("span", { className: styles.desktopOnlyLabel }, "Edit"))),
                react_1.default.createElement(kaleidoscope_1.CopyToClipboard, { value: url, tooltip: {
                        content: (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" },
                            react_1.default.createElement(kaleidoscope_2.Label, { size: "s", theme: "dark" }, "Collaborator link"),
                            react_1.default.createElement(kaleidoscope_2.Text, { size: "s", theme: "dark" }, "Share this link with collaborators for review"))),
                        size: kaleidoscope_2.TooltipSize.Large,
                    } }, function (_a) {
                    var onCopy = _a.onCopy;
                    return (react_1.default.createElement(kaleidoscope_2.Button, { type: kaleidoscope_2.ButtonType.Primary, size: kaleidoscope_2.ButtonSize.Small, onClick: function () { return onCopyCollaboratorLinkClicked(onCopy); } },
                        react_1.default.createElement(icons_1.Team, { className: styles.hideOnMobile }),
                        "Copy link"));
                }))),
        showInviteModal && react_1.default.createElement(CollaboratorInviteModal_1.default, { closeModal: function () { return setShowInviteModal(false); } }),
        react_1.default.createElement(CollaboratorCommentPopup_1.default, { publicApiBaseUrl: publicApiBaseUrl })));
};
exports.CollaboratorPageNavbarName = "CollaboratorPageNavbar";
exports.CollaboratorPageNavbarWithHydration = (0, hydrationHelpers_1.withHydrationHost)(CollaboratorPageNavbar, {
    componentName: exports.CollaboratorPageNavbarName,
});
var renderNavBar = function (editPageButtonUrl, clientUrl, publicApiBaseUrl) {
    return server_1.default.renderToString(react_1.default.createElement(exports.CollaboratorPageNavbarWithHydration, {
        editPageButtonUrl: editPageButtonUrl,
        clientUrl: clientUrl,
        publicApiBaseUrl: publicApiBaseUrl,
    }));
};
exports.renderNavBar = renderNavBar;
